import { Routes, RouterModule }  from '@angular/router';
import { Pages } from './pages.component';
import { ModuleWithProviders } from '@angular/core';
import { CanActivateViaAuthGuard } from '../theme/guards/canactivate.guard';

// noinspection TypeScriptValidateTypes

// export function loadChildren(path) { return System.import(path); };

export const routes: Routes = [
  { path: '', redirectTo: 'login',pathMatch:"full"},
  {
    path: 'login',
    loadChildren: 'app/pages/login/login.module#LoginModule'
  },
  {
    path: '',
    component: Pages,
    canActivate: [CanActivateViaAuthGuard],
    children:[
      { path: 'dashboard', loadChildren: './dashboard/dashboard.module#DashboardModule'},
      { path: 'localization', loadChildren: './localization/localization.module#LocalizationModule'},
      { path: 'institutions', loadChildren: './institutions/institutions.module#InstitutionsModule'},
      { path: 'funds', loadChildren: './funds/funds.module#FundsModule'},
      { path: 'reported-cases', loadChildren: './reported-cases/reported-cases.module#ReportedCasesModule'},
      { path: 'users', loadChildren: './users/users.module#UsersModule'},
      {path:'digital-tools',loadChildren:'./digital-tools/digital-tools.module#DigitalToolsModule'},
      {path:'projects',loadChildren:'./projects/projects.module#ProjectsModule'},
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts